/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    bool, func, string, object,
    arrayOf, shape, number,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import mbpLogger from 'mbp-logger';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';

import Loading from '../../../common/Loading';
import BackButton from '../../../common/BackButton';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';
import { getBrand, getCustomerEmail } from '../../../state/ducks/Common/Common-Selectors';

import SubscriptionList from './SubscriptionList';
import SubscriptionDetail from './SubscriptionDetail';

const { PERSIST_KEY } = configENV;

const LIST_MODE = 'list';
const DETAIL_MODE = 'detail';

const styles = theme => ({   // eslint-disable-line
    defaultBody: {
        color: '#666',
    },
    subheadText: {
        marginBottom: '20px',
        fontStyle: 'italic',
        color: theme.palette.colorAlert,
    },
});

class MobileSubscriptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            mode: LIST_MODE,
            subscriptionRuleId: '',
        };

        const { customerId, fetchSubscriptions, brand, subscriptions } = props;  // eslint-disable-line object-curly-newline
        fetchSubscriptions(customerId, brand, subscriptions);  // fetch subscriptions into newState
    }

    static getDerivedStateFromError(/* error */) {
        return { hasError: true };
    }

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    componentDidCatch = (jsError, reactInfo) => {
        mbpLogger.logError({
            message: `Unhandled Error in MobileSubscriptions \n jsError = ${jsError} \n reactInfo = ${reactInfo}`,
            module: 'mbp-pwa-ui',
        });
    }

    handleSubscriptionSelectedFromList = (subscriptionRuleId) => {
        this.setState({ mode: DETAIL_MODE, subscriptionRuleId });
    };

    handleSubscriptionDetailClose = () => {
        this.setState({ mode: LIST_MODE, subscriptionRuleId: '' });
    };

    handleCancelSubscription = () => {
        const { subscriptionRuleId } = this.state;
        const { cancelSubscription, brand } = this.props;
        cancelSubscription(subscriptionRuleId, brand);
        this.handleSubscriptionDetailClose();
    }

    render() {
        const { mode, subscriptionRuleId, error, hasError } = this.state;   // eslint-disable-line object-curly-newline
        const { isFetchingModal, classes } = this.props;

        if (error || hasError) {
            return <div>Sorry! - we were unable to access your subscriptions.<br />Please try again later.</div>;
        }

        if (isFetchingModal) {
            return <Loading pageTitle="Manage Subscriptions" />;
        }

        const subHead = <div className={classes.subheadText}>Your default card will be used for Subscription orders.</div>;

        switch (mode) {
            case LIST_MODE:
                return (
                    <div className={classes.defaultBody}>
                        <h1><BackButton /> Manage Subscriptions</h1>
                        {subHead}
                        <SubscriptionList handleSelect={this.handleSubscriptionSelectedFromList} />
                    </div>
                );
            case DETAIL_MODE:
                return (
                    <div className={classes.defaultBody}>
                        <h1><Button onClick={this.handleSubscriptionDetailClose}><ArrowBack /> BACK</Button></h1>
                        {subHead}
                        <SubscriptionDetail subscriptionRuleId={subscriptionRuleId} handleCancel={this.handleCancelSubscription} />
                    </div>
                );
            default:
                return null;
        }
    }
}

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        brand: getBrand(state),
        customerId: getCustomerEmail(state),
        subscriptions: newState.subscriptions,
    };
};

MobileSubscriptions.defaultProps = {
    fetchSubscriptions: () => { },
    cancelSubscription: () => { },
    subscriptions: [],
};

MobileSubscriptions.propTypes = {
    customerId: string.isRequired,
    isFetchingModal: bool.isRequired,
    fetchSubscriptions: func,
    cancelSubscription: func,
    brand: object.isRequired,
    subscriptions: arrayOf(
        shape({
            checkoutBrand: string,
            duration: number.isRequired,
            endDate: string.isRequired,
            interval: number.isRequired,
            nextOrderDate: string,
            orderDate: string.isRequired,
            orderHistoryResult: arrayOf(
                shape({
                    deliveryDate: string,
                    discountAmount: string,
                    orderDate: string.isRequired,
                    orderNumber: string.isRequired,
                    productCode: string.isRequired,
                    productName: string.isRequired,
                    productPrice: string.isRequired,
                    quantity: string.isRequired,
                }),
            ),
            orderNumber: string.isRequired,
            orderTime: string.isRequired,
            orderType: string.isRequired,
            price: string.isRequired,
            productId: string.isRequired,
            productImageCategory: string.isRequired,
            productImageThumbnail: string.isRequired,
            productName: string.isRequired,
            quantity: string,
            recipient: arrayOf(shape({
                city: string.isRequired,
                country: string.isRequired,
                firstName: string.isRequired,
                lastName: string.isRequired,
                state: string.isRequired,
                street1: string.isRequired,
                street2: string.isRequired,
                zipcode: string.isRequired,
            })),
            ruleId: string.isRequired,
            startDate: string.isRequired,
            subscriptionStatus: string.isRequired,
            totalAmount: string.isRequired,
        }),
    ),
    classes: object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    fetchSubscriptions: (customerId, brand, subscriptions) => dispatch(EventDispatcher.fetchSubscriptions(customerId, brand, subscriptions)),
    cancelSubscription: (ruleId, brand) => dispatch(EventDispatcher.cancelSubscription(ruleId, brand)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles, { withTheme: true })(MobileSubscriptions)));
